import React, {useEffect} from 'react';
import CodePrompt from "./CodePrompt";
import {useRsvp} from "../context/RsvpContext";

/**
 * Renders the section containing the code prompt, with a textured background and a looping video.
 */
const CodeEntrySection: React.FC = () => {
    const {sendCode, isLoading, error} = useRsvp();

    useEffect(() => {
        const savedCode = sessionStorage.getItem('rsvp_code');
        if (savedCode) {
            sendCode(savedCode);
        }
    }, [sendCode]);

    const handleSubmit = async (code: string) => {
        sessionStorage.setItem('rsvp_code', code);
        await sendCode(code);
    };

    return (
        <section className="relative w-full h-[40svh] overflow-hidden">
            <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: 'url("images/GreenTexture.png")'
                }}>
                <video
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{mixBlendMode: 'multiply'}}
                    autoPlay loop muted playsInline>
                    <source src="/Leaves.mp4" type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
                <div className="max-w-2xl mx-auto mt-16">
                    <CodePrompt
                        onSubmit={handleSubmit}
                        isLoading={isLoading}
                        error={error}
                    />
                </div>
            </div>
        </section>
    );
};

export default CodeEntrySection;